import moment from "moment";

export function getDate(date) {
    return moment(date).format("Do MMM YYYY")
}

export function getDateWithTime(date) {
    return `${moment(date).format("Do MMM YYYY")} at ${moment(date).format("HH:mm")}`
}

export function getYear(date) {
    return `${moment(date).format("YYYY")}`;
}

export function getMonth(date) {
    return `${moment(date).format("MMMM")}`;
}

export function getTime(date) {
    return `${moment(date).format("HH:mm")}`
}



export function getDateForInput(date) {
    return moment(date).format("YYYY-MM-DD")
}


export function formatDateToISOString(dateString) {
    // Create a new Date object using the input date string
    const date = new Date(dateString);
  
    // Get the UTC time by subtracting the timezone offset
    const utcTime = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    );
  
    // Create a new Date object using the UTC time
    const utcDate = new Date(utcTime);
  
    // Convert the UTC date to ISO string
    const formattedDate = utcDate.toISOString();
  
    return formattedDate;
  };

  export const getOnlyMonthandYear=(dateString)=>
  {
   return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(new Date(dateString))
  }

 export function getPreviousMonthDate(date) {
    const previousMonthDate = new Date(date);
    previousMonthDate.setMonth(date.getMonth() - 1);
    return previousMonthDate;
  }

  export function currentDateplusone()
  {
    let currentDate = new Date();

// Add one day to the current date
currentDate.setDate(currentDate.getDate() + 1);

// Log the new date

return currentDate
  }

  export function recievedDateplusOne(recievedDate)
  {
    let dateRecieved = recievedDate;

// Add one day to the current date
dateRecieved.setDate(dateRecieved.getDate() + 1);

// Log the new date

return dateRecieved
  }

  export function formatDate(date) {
    const options = {
      month: 'short',   // e.g., "Jan"
      day: 'numeric',   // e.g., "13"
      year: 'numeric',  // e.g., "2024"
      hour: 'numeric',  // e.g., "2"
      minute: 'numeric',// e.g., "30"
      hour12: true,     // 12-hour format with AM/PM
      timeZoneName: 'short' // e.g., "AST"
    };
  
    return date.toLocaleString('en-US', options);
  }
  